import {
  Card,
  Form,
  Image,
  Input,
  notification,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import Button from "../../../components/common/button";
import Dropdown from "../../../components/common/dropdown";
import TextArea from "../../../components/common/textArea";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { sendNotifications } from "../../../api/notification";
import { fetchBusiness, reset } from "../../../store/slices/businessSlice";
import DeleteMemberModal from "../../../components/common/modalMember";
import { getBusinessServices } from "../../../api/service";
import colors from "../../../share/constants/constants";
import ImageUpload from "../../../components/common/imageUpload";
import { Link } from "react-router-dom";
import { CloseCircleOutlined, NotificationOutlined } from "@ant-design/icons";
import ServiceCard from "../orders/allOrders/serviceCard";

const Notifications = () => {
  const businessNames = useSelector((state) => state?.business?.res?.items);
  const isBusinessLoading = useSelector((state) => state?.business?.isLoading);
  const [openModal, setOpenModal] = useState(false);
  const [values, setValues] = useState();
  const dispatch = useDispatch();
  const [body, setBody] = useState();
  const [isServiceLoading, setIsServiceLoading] = useState(false);
  const [services, setServices] = useState([]);
  const [selectBusinessId, setSelectBusinessId] = useState(null);
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  const [loader, setLoader] = useState(false);
  const hideModal = () => {
    setOpenModal(false);
  };
  const yesClickHandler = () => {
    onFinish();
    setOpenModal(false);
  };
  const radius = [
    {
      _id: "15",
      name: 15,
    },
    {
      _id: "30",
      name: 30,
    },
    {
      _id: "50",
      name: 50,
    },
    {
      _id: "ALL",
      name: "ALL",
    },
  ];

  const [form] = Form.useForm();

  const onFinish = async () => {
    setLoader(true);
    const payload = {
      miles: values.miles,
      businessId: values.businessId,
      body: body,
      title: values.title,
      serviceId: values.serviceId,
    };
    if(selectedService) { 
      payload.coords = selectedService?.businessId?.businessLocation?.coordinates
    }
    if (imageFile) payload.image = imageFile;
    const res = await sendNotifications(payload);
    if (res) {
      setSelectBusinessId(null);
      setSelectedBusiness(null);
      setSelectedService(null);
      setImageFile(null);
      form.resetFields();
      setBody("");
      notification.success({
        message: "Success",
        description: "Notification sent successfully",
      });
      setServices([]);
      setLoader(false);
    }
    setLoader(false);
  };

  const handleTextChange = (e) => {
    setBody(e);
    form.setFieldsValue({ body: e });
  };

  const handleButtonClick = (values) => {
    setOpenModal(true);
    setValues(values);
  };

  const loadMoreData = (page, itemPerPage = 10, text = "") => {
    const payload = {
      pageNumber: page,
      itemPerPage: itemPerPage,
    };
    if(text) {
      payload.text = text;
      payload.isLoadMore = true
    }
    dispatch(fetchBusiness(payload));
  };

  const fetchBusinessByName = (payload) => {
    if(payload?.pageNumber === 1 && payload?.text) {
      dispatch(reset());
    }
    dispatch(fetchBusiness(payload));
  }

  useEffect(() => {
    const payload = {
      pageNumber: 1,
      itemPerPage: 10,
    };
    dispatch(fetchBusiness(payload));
  }, []);

  const getServicesByBusinessId = async (businessId, page) => {
    setIsServiceLoading(true);
    const res = await getBusinessServices({
      pageNumber: page,
      pageSize: 10,
      businessId: businessId,
    });
    if(res)
    {
      setServices((prevServices) => [...prevServices, ...res?.items]);
    }
    setIsServiceLoading(false);
  };

  const handleBusinessChange = async (businessId) => {
    setSelectBusinessId(businessId);
    setSelectedBusiness((businessNames || []).find((b) => b._id === businessId));
    setSelectedService(null);
    setServices([]);
    form.setFieldsValue({ serviceId: undefined });
    await getServicesByBusinessId(businessId, 1);
  };

  const handleServiceChange = (serviceId) => {
    setSelectedService(services.find((s) => s._id === serviceId));
  };

  const loadMoreServiceData = async (page) => {
    await getServicesByBusinessId(selectBusinessId, page);
  };

  const handleImageUpload = (newImage) => {
    setImageFile(newImage);
  };

  const openNotificationWithImage = () => {
    if (!form?.getFieldValue("title") || !form?.getFieldValue("body"))
      return notification.open({ message: "Please add Title and Body" });
    notification.open({
      message: form?.getFieldValue("title"),
      description: (
        <div>
          <p>{form?.getFieldValue("body")}</p>
          {imageFile && (
            <Image
              src={imageFile}
              width={335}
              height={120}
              preview={false}
              alt="attachment"
              className="object-cover"
            />
          )}
        </div>
      ),
      duration: 4,
      placement: "topRight",
    });
  };

  const contentStyle = {
    lineHeight: "20px",
    textAlign: "left",
    color: colors.primaryPurple,
    backgroundColor: colors.dropdownGrey,
    borderRadius: 10,
    border: `1px dashed ${colors.primaryPurple}`,
    // marginTop: 16,
  };
  const onDropDownClose = () => {
    dispatch(reset());
    const payload = {
      pageNumber: 1,
      itemPerPage: 10,
    };
    dispatch(fetchBusiness(payload));
  }

  return (
    <div>
      <div className="grid gap-x-1 gap-y-1 space-x-2 w-full pr-2">
        <div className="flex pt-3 pl-3 place-content-between">
          <Link to="/main/customers">
            <div className="flex items-center">
              <span className="text-lg font-bold text-black">
                Notifications
              </span>
            </div>
          </Link>
        </div>
        <Card className="rounded-2xl bg-white xl:relative">
          <div className="border-solid border-inputFieldGrey rounded-sm p-2">
            <Form
              className="mt-1"
              layout="vertical"
              onFinish={handleButtonClick}
              form={form}
            >
              <div className="sm:grid sm:grid-cols-2 gap-x-2 gap-y-1 px-2">
                <div>
                  {" "}
                  <Typography.Title level={5} className="mt-0 mb-2">
                    Step 1. Select Vendor & Service
                  </Typography.Title>
                </div>
                <div></div>
                <Form.Item
                  name="businessId"
                  label="Vendor"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Dropdown
                    className={"h-5 !rounded-lg"}
                    placeholder="Choose Vendor"
                    isBusiness={true}
                    loadMoreData={(e, itemParPage, text) => {
                      loadMoreData(e, itemParPage, text);
                    }}
                    data={businessNames || []}
                    onChange={handleBusinessChange}
                    loader={isBusinessLoading}
                    fetchData={fetchBusinessByName}
                    onDropDownClose={onDropDownClose}
                  />
                </Form.Item>
                <Form.Item
                  name="serviceId"
                  label="Service/Deal"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Dropdown
                    className={"h-5 !rounded-lg"}
                    placeholder="Choose Service"
                    isService={true}
                    loadMoreData={(e) => {
                      loadMoreServiceData(e);
                    }}
                    data={services}
                    onChange={handleServiceChange}
                    loader={isServiceLoading}
                  />
                </Form.Item>
                <div>
                  <Typography.Title level={5} className="mt-0 mb-2">
                    Step 2. Choose Radius
                  </Typography.Title>
                </div>
                <div></div>
                <Form.Item
                  name="miles"
                  label="Radius"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Dropdown
                    className={"h-5 !rounded-lg"}
                    placeholder="Choose Radius"
                    data={radius}
                  />
                </Form.Item>
                <div></div>
                <div>
                  <Typography.Title level={5} className="mt-0 mb-2">
                    Step 3. Add Notification Title*, Body* & Upload Image
                    (optional)
                  </Typography.Title>
                </div>
                <div></div>
                <Form.Item
                  name="title"
                  label="Title"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Input
                    showCount
                    maxLength={50}
                    placeholder="Type Title (e.g $$ off on Oil Change)"
                    className="h-5.4 focus:bg-white focus:border-primaryPurple hover:border-primaryPurple"
                  />
                </Form.Item>
                <Form.Item name="image" label="Notification Banner Image">
                  <div className="w-full flex space-x-1">
                    <ImageUpload
                      className="!w-full hover:border-primaryPurple h-5.4"
                      onUploadSuccess={handleImageUpload}
                      initialImage={imageFile}
                    />
                    {imageFile && (
                      <>
                        <Image
                          src={imageFile}
                          width={100}
                          height={54}
                          preview={true}
                          alt="attachment"
                          className="rounded object-cover"
                        />
                        <div className="cursor-pointer">
                          <CloseCircleOutlined
                            onClick={() => handleImageUpload("")}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </Form.Item>
                <Form.Item
                  name="body"
                  label="Notification Description"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <TextArea
                    showCount
                    maxLength={100}
                    placeholder={"Type Notification Description (Body)"}
                    className="rounded-xl hover:border-primaryPurple"
                    handleTextChange={handleTextChange}
                  />
                </Form.Item>
                <div className="flex flex-col justify-center items-center gap-y-1">
                  <Tooltip placement="top" title={"See how it will look"}>
                    <Tag
                      color="success"
                      className="cursor-pointer"
                      onClick={() => openNotificationWithImage()}
                      icon={<NotificationOutlined />}
                    >
                      Test Notification
                    </Tag>
                  </Tooltip>
                  <Button
                    className="w-full"
                    title="Send Notification"
                    color={colors.primaryPurple}
                    htmlType="submit"
                    loading={loader}
                  />
                </div>
              </div>
            </Form>
            {selectedBusiness && (
              <div>
                <div className="p-2">
                  <h3 className="text-lg font-semibold mt-0">
                    Selected Service
                  </h3>
                  {selectedService && (
                    <>
                      <ServiceCard
                        services={selectedService}
                        business={selectedService?.businessId}
                        showExtra={false}
                      />
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </Card>
      </div>

      {openModal && (
        <DeleteMemberModal
          title="Send Notification"
          text="Are you sure you want to send notification to these customers?"
          onCancel={hideModal}
          onOk={yesClickHandler}
        />
      )}
    </div>
  );
};
export default Notifications;